import { schema } from "normalizr";

const OrderSchema = new schema.Entity(
    "orders",
    {},
    {
        idAttribute: "_id",
    }
);

export default OrderSchema;
